import { useIsBoreaRep } from "hooks/useIsBoreaRep";
import { Navigate, useRoutes } from "react-router-dom";
import { canPortfolioTrade } from "services/permissions/trading";
import {
  PermissionMode,
  usePermission,
} from "services/permissions/usePermission";
import { NavTabLayout } from "../NavTabLayout";
import { NavTabPath } from "./types";

interface NavTabRoutesProps {
  routes: NavTabPath[];
}

export const NavTabRoutes = ({ routes }: NavTabRoutesProps) => {
  const canTrade = usePermission(
    PermissionMode.SELECTED_ANY,
    canPortfolioTrade
  );
  const isBoreaRep = useIsBoreaRep();

  const filteredRoutes = routes.filter((route) => {
    if (route.path === "trading") return canTrade;
    if (route.path === "advisor") return isBoreaRep;
    return true;
  });

  return useRoutes([
    {
      path: "",
      element: <NavTabLayout routes={filteredRoutes} />,
      children: filteredRoutes,
    },
    {
      path: "*",
      element: <Navigate to="overview" replace />,
    },
  ]);
};
